// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../../legacy/app/node_modules/bm-cs-swaggergen/dist/models/modelReferences.d.ts" />

import { Component, OnChanges, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-email-list',
	templateUrl: './email-list.component.html',
	styleUrls: ['./email-list.component.css']
})
export class EmailListComponent implements OnChanges {

	@Input() emailAddresses: cs.IContactEmailV2Dto[];

	public primaryEmailAddress: cs.IContactEmailV2Dto;
	public otherEmailAddresses: cs.IContactEmailV2Dto[];

	constructor(
		private translate: TranslateService
	) { }

	ngOnChanges() {
		this.setEmailAddress();
	}

	public formatPrimaryString(primary: string): string {
		if (!primary) {
			return '';
		}
		return `${primary} (${this.translate.instant('Onvio.Reports.ClientDashboard.Primary')})`;
	}

	// format and set the email address
	public setEmailAddress() {
		this.primaryEmailAddress = null;
		const emails = this.emailAddresses;
		for (const i in emails) {
			if (emails[i].isPrimary) {
				this.primaryEmailAddress = emails[i];
			}
		}
		if (emails) {
			this.otherEmailAddresses = emails.filter((email: cs.IContactEmailV2Dto) => !email.isPrimary);
		} else {
			this.otherEmailAddresses = [];
		}
	}
}
